import React, { useMemo, useState } from "react";

import {
  faWallet,
  faCoins,
  faGift,
  faTrophy,
  faShareNodes,
  faDownload,
  faHeartPulse,
  faDumbbell,
  faBookOpen,
  faSpa,
  faPersonWalking,
  faMedal,
  faCircleCheck,
  faFire,
  faRankingStar,
  faBrain,
  faMoon,
  faGlassWater,
  faChartLine,
  faUsers,
  faCrown,
  faStar,
  faArrowTrendUp,
  faCalendarCheck,
  faBolt,
  faSeedling,
  faFaceSmile,
  faBagShopping,
  faLaptop,
  faHandsHelping,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import QRCode from "react-qr-code";

const SheScoreHome = () => {
  const [rewardTab, setRewardTab] = useState("all");

  /* =========================================================
      USER
  ========================================================= */

  const user = {
    name: "Ananya Sharma",
    sheCode: "SHE-2048",
    shePoints: 12840,
    glowScore: 88,
    growthScore: 76,
    impactScore: 64,
    streak: 18,
    rank: 7,
    level: "Glow Leader",
  };

  /* =========================================================
      DAILY CHECKINS
  ========================================================= */

  const checkins = [
    {
      title: "Hydration Goal",
      progress: "7/8 Glasses",
      icon: faGlassWater,
      color: "border-cyan-500",
    },
    {
      title: "Meditation",
      progress: "20 mins",
      icon: faBrain,
      color: "border-purple-500",
    },
    {
      title: "Sleep",
      progress: "7.5 hrs",
      icon: faMoon,
      color: "border-indigo-500",
    },
    {
      title: "Workout",
      progress: "5,200 steps",
      icon: faPersonWalking,
      color: "border-pink-500",
    },
  ];

  /* =========================================================
      TRANSFORMATION FEED
  ========================================================= */

  const feed = [
    {
      id: 1,
      title: "Completed 7-Day Mindfulness Challenge",
      points: "+420",
      icon: faSpa,
      time: "2 hrs ago",
    },
    {
      id: 2,
      title: "Purchased Women Wellness Kit",
      points: "+180",
      icon: faBagShopping,
      time: "Yesterday",
    },
    {
      id: 3,
      title: "Completed Financial Literacy Course",
      points: "+650",
      icon: faLaptop,
      time: "2 days ago",
    },
  ];

  /* =========================================================
      CHALLENGES
  ========================================================= */

  const challenges = [
    {
      id: 1,
      title: "21-Day Self Love Challenge",
      participants: 8240,
      reward: "800 Points",
      icon: faHeartPulse,
    },
    {
      id: 2,
      title: "Fitness Glow Sprint",
      participants: 5200,
      reward: "500 Points",
      icon: faDumbbell,
    },
    {
      id: 3,
      title: "Read & Rise Challenge",
      participants: 2140,
      reward: "300 Points",
      icon: faBookOpen,
    },
  ];

  /* =========================================================
      REWARDS
  ========================================================= */

  const rewards = [
    {
      id: 1,
      title: "Salon & Spa Voucher",
      points: 1500,
      badge: "Popular",
    },
    {
      id: 2,
      title: "Premium Wellness Session",
      points: 2400,
      badge: "Glow Pick",
    },
    {
      id: 3,
      title: "Women Leadership Workshop",
      points: 3200,
      badge: "Career Boost",
    },
    {
      id: 4,
      title: "Luxury Self-Care Hamper",
      points: 5000,
      badge: "Premium",
    },
  ];

  /* =========================================================
      LEADERBOARD
  ========================================================= */

  const leaderboard = [
    {
      id: 1,
      name: "Priya Mehta",
      score: 22840,
      rank: 1,
    },
    {
      id: 2,
      name: "Ritika Jain",
      score: 19400,
      rank: 2,
    },
    {
      id: 3,
      name: "Ayesha Khan",
      score: 18220,
      rank: 3,
    },
    {
      id: 4,
      name: "You",
      score: 12840,
      rank: 7,
    },
  ];

  /* =========================================================
      COMMUNITY
  ========================================================= */

  const community = [
    {
      id: 1,
      title: "Helped 12 women in career mentorship",
      icon: faHandsHelping,
      impact: "+300 ImpactScore",
    },
    {
      id: 2,
      title: "Shared wellness transformation story",
      icon: faSeedling,
      impact: "+180 Community Score",
    },
  ];

  /* =========================================================
      REFERRAL
  ========================================================= */

  const referralLink = `https://www.think5whys.com/shescore?ref=${user.sheCode}`;

  const handleShare = async () => {
    const shareText = `
🌸 Join SheScore

Earn rewards for wellness, growth,
fitness, learning & transformation.

Referral Code: ${user.sheCode}

${referralLink}
`;

    try {
      if (navigator.share) {
        await navigator.share({
          title: "SheScore",
          text: shareText,
          url: referralLink,
        });
      } else {
        await navigator.clipboard.writeText(shareText);
        alert("Referral copied!");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleDownload = () => {
    window.print();
  };

  /* =========================================================
      FILTER
  ========================================================= */

  const filteredRewards = useMemo(() => {
    if (rewardTab === "all") return rewards;

    return rewards.filter(
      (reward) => reward.points <= user.shePoints
    );
  }, [rewardTab]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#140b1f] via-[#1b1028] to-black text-white px-3 py-4">

      {/* =====================================================
          HERO
      ===================================================== */}

      <div className="rounded-3xl overflow-hidden bg-gradient-to-r from-pink-600 via-fuchsia-600 to-purple-700 shadow-2xl p-5">

        <div className="flex flex-col lg:flex-row gap-5 lg:items-center lg:justify-between">

          <div>

            <div className="inline-flex items-center gap-2 bg-white/20 px-3 py-1 rounded-full text-xs mb-3">
              <FontAwesomeIcon icon={faStar} />
              Women Transformation Platform
            </div>

            <h1 className="text-4xl font-black tracking-tight">
              🌸 SheScore
            </h1>

            <p className="mt-3 text-sm text-pink-50 max-w-2xl leading-relaxed">
              Earn ShePoints for wellness, learning, fitness,
              self-growth, community impact, shopping,
              entrepreneurship and transformation milestones.
            </p>

            <div className="flex flex-wrap gap-2 mt-4">

              <div className="bg-white/20 px-3 py-1 rounded-full text-xs">
                💖 Wellness
              </div>

              <div className="bg-white/20 px-3 py-1 rounded-full text-xs">
                📚 Learning
              </div>

              <div className="bg-white/20 px-3 py-1 rounded-full text-xs">
                🏆 Challenges
              </div>

              <div className="bg-white/20 px-3 py-1 rounded-full text-xs">
                🌱 Growth Tracking
              </div>

            </div>

          </div>

          <div className="bg-white rounded-3xl p-4">

            <QRCode
              value={referralLink}
              size={130}
            />

          </div>

        </div>

      </div>

      {/* =====================================================
          SCORE DASHBOARD
      ===================================================== */}

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mt-4">

        <div className="bg-[#231232] border border-pink-500 rounded-3xl p-4">

          <div className="flex items-center justify-between">
            <FontAwesomeIcon icon={faWallet} className="text-pink-300 text-xl" />
            <span className="text-xs text-pink-100">
              ShePoints
            </span>
          </div>

          <h2 className="text-3xl font-black mt-3 text-yellow-200">
            {user.shePoints}
          </h2>

          <p className="text-xs text-pink-100 mt-1">
            Total Rewards
          </p>

        </div>

        <div className="bg-[#231232] border border-yellow-500 rounded-3xl p-4">

          <div className="flex items-center justify-between">
            <FontAwesomeIcon icon={faFaceSmile} className="text-yellow-300 text-xl" />
            <span className="text-xs text-yellow-100">
              GlowScore
            </span>
          </div>

          <h2 className="text-3xl font-black mt-3 text-yellow-200">
            {user.glowScore}
          </h2>

          <p className="text-xs text-yellow-100 mt-1">
            Wellness Index
          </p>

        </div>

        <div className="bg-[#231232] border border-cyan-500 rounded-3xl p-4">

          <div className="flex items-center justify-between">
            <FontAwesomeIcon icon={faChartLine} className="text-cyan-300 text-xl" />
            <span className="text-xs text-cyan-100">
              Growth
            </span>
          </div>

          <h2 className="text-3xl font-black mt-3 text-yellow-200">
            {user.growthScore}
          </h2>

          <p className="text-xs text-cyan-100 mt-1">
            Learning Score
          </p>

        </div>

        <div className="bg-[#231232] border border-green-500 rounded-3xl p-4">

          <div className="flex items-center justify-between">
            <FontAwesomeIcon icon={faUsers} className="text-green-300 text-xl" />
            <span className="text-xs text-green-100">
              Impact
            </span>
          </div>

          <h2 className="text-3xl font-black mt-3 text-yellow-200">
            {user.impactScore}
          </h2>

          <p className="text-xs text-green-100 mt-1">
            Community Influence
          </p>

        </div>

        <div className="bg-[#231232] border border-orange-500 rounded-3xl p-4">

          <div className="flex items-center justify-between">
            <FontAwesomeIcon icon={faFire} className="text-orange-300 text-xl" />
            <span className="text-xs text-orange-100">
              Streak
            </span>
          </div>

          <h2 className="text-3xl font-black mt-3 text-yellow-200">
            {user.streak}
          </h2>

          <p className="text-xs text-orange-100 mt-1">
            Transformation Days
          </p>

        </div>

      </div>

      {/* =====================================================
          MAIN GRID
      ===================================================== */}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-4">

        {/* CHECKINS */}

        <div className="bg-[#1f122d] rounded-3xl border border-[#3a2350] p-4">

          <h3 className="text-lg font-bold text-pink-200 mb-4">
            <FontAwesomeIcon
              icon={faHeartPulse}
              className="mr-2 text-pink-300"
            />
            Daily Wellness
          </h3>

          <div className="space-y-3">

            {checkins.map((item, index) => (
              <div
                key={index}
                className={`bg-[#2a173d] rounded-2xl border ${item.color} p-3`}
              >

                <div className="flex items-center justify-between">

                  <div className="flex items-center gap-3">

                    <div className="w-12 h-12 rounded-2xl bg-black/20 flex items-center justify-center">
                      <FontAwesomeIcon
                        icon={item.icon}
                        className="text-pink-300"
                      />
                    </div>

                    <div>
                      <h4 className="font-semibold text-sm">
                        {item.title}
                      </h4>

                      <p className="text-xs text-gray-300">
                        {item.progress}
                      </p>
                    </div>

                  </div>

                  <FontAwesomeIcon
                    icon={faCircleCheck}
                    className="text-green-400"
                  />

                </div>

              </div>
            ))}

          </div>

        </div>

        {/* TRANSFORMATION FEED */}

        <div className="lg:col-span-2 bg-[#1f122d] rounded-3xl border border-[#3a2350] p-4">

          <div className="flex items-center justify-between mb-4">

            <h3 className="text-lg font-bold text-cyan-200">
              <FontAwesomeIcon
                icon={faArrowTrendUp}
                className="mr-2 text-cyan-300"
              />
              Transformation Feed
            </h3>

            <div className="text-xs text-gray-300">
              Latest Activities
            </div>

          </div>

          <div className="space-y-3">

            {feed.map((item) => (
              <div
                key={item.id}
                className="bg-[#2a173d] rounded-2xl p-4 flex items-center justify-between"
              >

                <div className="flex items-center gap-3">

                  <div className="w-14 h-14 rounded-2xl bg-pink-500/20 flex items-center justify-center">
                    <FontAwesomeIcon
                      icon={item.icon}
                      className="text-pink-300 text-lg"
                    />
                  </div>

                  <div>
                    <h4 className="font-semibold text-sm">
                      {item.title}
                    </h4>

                    <p className="text-xs text-gray-400 mt-1">
                      {item.time}
                    </p>
                  </div>

                </div>

                <div className="text-yellow-300 font-bold">
                  {item.points}
                </div>

              </div>
            ))}

          </div>

        </div>

      </div>

      {/* =====================================================
          CHALLENGES
      ===================================================== */}

      <div className="bg-[#1f122d] rounded-3xl border border-[#3a2350] p-4 mt-4">

        <div className="flex items-center justify-between mb-4">

          <h3 className="text-lg font-bold text-yellow-200">
            <FontAwesomeIcon
              icon={faBolt}
              className="mr-2 text-yellow-300"
            />
            Active Challenges
          </h3>

          <div className="text-xs text-gray-300">
            Earn bonus transformation points
          </div>

        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">

          {challenges.map((challenge) => (
            <div
              key={challenge.id}
              className="bg-[#2a173d] rounded-3xl p-4 border border-pink-500/20"
            >

              <div className="w-14 h-14 rounded-2xl bg-pink-500/20 flex items-center justify-center mb-4">
                <FontAwesomeIcon
                  icon={challenge.icon}
                  className="text-pink-300 text-xl"
                />
              </div>

              <h4 className="font-bold text-gray-100">
                {challenge.title}
              </h4>

              <p className="text-xs text-gray-400 mt-2">
                👭 {challenge.participants} participants
              </p>

              <div className="mt-4 text-yellow-300 font-bold">
                🎁 {challenge.reward}
              </div>

              <button
                type="button"
                className="w-full mt-4 bg-pink-500 hover:bg-pink-600 py-2 rounded-2xl font-semibold transition"
              >
                Join Challenge
              </button>

            </div>
          ))}

        </div>

      </div>

      {/* =====================================================
          REWARDS
      ===================================================== */}

      <div className="bg-[#1f122d] rounded-3xl border border-[#3a2350] p-4 mt-4">

        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 mb-4">

          <h3 className="text-lg font-bold text-pink-200">
            <FontAwesomeIcon
              icon={faGift}
              className="mr-2 text-pink-300"
            />
            Rewards Marketplace
          </h3>

          <div className="flex gap-2">

            <button
              type="button"
              onClick={() => setRewardTab("all")}
              className={`px-3 py-1 rounded-full text-xs ${
                rewardTab === "all"
                  ? "bg-pink-500"
                  : "bg-[#2a173d]"
              }`}
            >
              All
            </button>

            <button
              type="button"
              onClick={() => setRewardTab("redeemable")}
              className={`px-3 py-1 rounded-full text-xs ${
                rewardTab === "redeemable"
                  ? "bg-yellow-400 text-black"
                  : "bg-[#2a173d]"
              }`}
            >
              Redeemable
            </button>

          </div>

        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">

          {filteredRewards.map((reward) => (
            <div
              key={reward.id}
              className="bg-[#2a173d] rounded-3xl p-4"
            >

              <div className="flex items-center justify-between">

                <div>
                  <h4 className="font-bold">
                    {reward.title}
                  </h4>

                  <p className="text-xs text-gray-400 mt-1">
                    {reward.points} points required
                  </p>
                </div>

                <div className="bg-pink-500/20 text-pink-300 text-xs px-2 py-1 rounded-full">
                  {reward.badge}
                </div>

              </div>

              <button
                type="button"
                disabled={reward.points > user.shePoints}
                className={`w-full mt-4 py-2 rounded-2xl font-semibold transition ${
                  reward.points <= user.shePoints
                    ? "bg-yellow-400 hover:bg-yellow-300 text-black"
                    : "bg-slate-700 text-gray-400 cursor-not-allowed"
                }`}
              >
                {reward.points <= user.shePoints
                  ? "Redeem Reward"
                  : "Not Enough Points"}
              </button>

            </div>
          ))}

        </div>

      </div>

      {/* =====================================================
          BOTTOM GRID
      ===================================================== */}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-4">

        {/* LEADERBOARD */}

        <div className="bg-[#1f122d] rounded-3xl border border-[#3a2350] p-4">

          <h3 className="text-lg font-bold text-yellow-200 mb-4">
            <FontAwesomeIcon
              icon={faRankingStar}
              className="mr-2 text-yellow-300"
            />
            SheLeaderboard
          </h3>

          <div className="space-y-3">

            {leaderboard.map((item) => (
              <div
                key={item.id}
                className={`rounded-2xl p-3 flex items-center justify-between ${
                  item.name === "You"
                    ? "bg-pink-500/20 border border-pink-400"
                    : "bg-[#2a173d]"
                }`}
              >

                <div className="flex items-center gap-3">

                  <div className="w-10 h-10 rounded-full bg-black/20 flex items-center justify-center">

                    {item.rank === 1 ? (
                      <FontAwesomeIcon
                        icon={faCrown}
                        className="text-yellow-300"
                      />
                    ) : (
                      item.rank
                    )}

                  </div>

                  <div>

                    <h4 className="font-semibold text-sm">
                      {item.name}
                    </h4>

                    <p className="text-xs text-gray-400">
                      Rank #{item.rank}
                    </p>

                  </div>

                </div>

                <div className="font-bold text-yellow-300">
                  {item.score}
                </div>

              </div>
            ))}

          </div>

        </div>

        {/* COMMUNITY */}

        <div className="bg-[#1f122d] rounded-3xl border border-[#3a2350] p-4">

          <h3 className="text-lg font-bold text-green-200 mb-4">
            <FontAwesomeIcon
              icon={faHandsHelping}
              className="mr-2 text-green-300"
            />
            Community Impact
          </h3>

          <div className="space-y-3">

            {community.map((item) => (
              <div
                key={item.id}
                className="bg-[#2a173d] rounded-2xl p-3"
              >

                <div className="flex items-start gap-3">

                  <div className="w-10 h-10 rounded-2xl bg-green-500/20 flex items-center justify-center">
                    <FontAwesomeIcon
                      icon={item.icon}
                      className="text-green-300"
                    />
                  </div>

                  <div>

                    <h4 className="font-semibold text-sm">
                      {item.title}
                    </h4>

                    <p className="text-xs text-green-300 mt-2">
                      {item.impact}
                    </p>

                  </div>

                </div>

              </div>
            ))}

          </div>

        </div>

        {/* REFERRAL */}

        <div className="bg-[#1f122d] rounded-3xl border border-[#3a2350] p-4">

          <h3 className="text-lg font-bold text-pink-200 mb-4">
            <FontAwesomeIcon
              icon={faShareNodes}
              className="mr-2 text-pink-300"
            />
            Invite & Earn
          </h3>

          <div className="bg-white rounded-3xl p-4 flex justify-center">

            <QRCode
              value={referralLink}
              size={180}
            />

          </div>

          <div className="text-center mt-4">

            <p className="text-xs text-gray-400">
              Referral Code
            </p>

            <h2 className="text-2xl font-black text-yellow-300 mt-1">
              {user.sheCode}
            </h2>

            <p className="text-xs text-gray-400 mt-2">
              Earn bonus ShePoints for every successful invite.
            </p>

          </div>

          <div className="grid grid-cols-2 gap-2 mt-4">

            <button
              type="button"
              onClick={handleShare}
              className="bg-pink-500 hover:bg-pink-600 py-2 rounded-2xl font-semibold transition"
            >
              <FontAwesomeIcon icon={faShareNodes} />
              <span className="ml-2">Share</span>
            </button>

            <button
              type="button"
              onClick={handleDownload}
              className="bg-purple-500 hover:bg-purple-600 py-2 rounded-2xl font-semibold transition"
            >
              <FontAwesomeIcon icon={faDownload} />
              <span className="ml-2">Save</span>
            </button>

          </div>

        </div>

      </div>

      {/* =====================================================
          FOOTER
      ===================================================== */}

      <div className="mt-6 text-center text-xs text-gray-500 pb-6">
        © 2026 SheScore • Women Transformation Intelligence Platform
      </div>

    </div>
  );
};

export default SheScoreHome;